import React from 'react'

function AboutLessonsLearned() {
    const lessons = [
        {
            num: '01',
            title: 'Speed Without Accuracy Is Just Expensive Incompetence.',
            text: 'Early on, we prioritized fast claims submission above everything else. We submitted quickly—straight into denials. We slowed down, built proper scrubbing and quality checks into the process and then ramped back up. We\'re still fast—but accuracy comes first, every time.',
            icon: 'fas fa-tachometer-alt',
        },
        {
            num: '02',
            title: 'Dedicated Teams Beat Shared Pools Every Time.',
            text: 'We tried rotating staff across multiple clients. It was a disaster. Knowledge got thin. Clients felt like they were re-explaining themselves every week. Now every client gets a dedicated team that learns their practice or business inside and out. The difference in outcomes isn\'t subtle.',
            icon: 'fas fa-users',
        },
        {
            num: '03',
            title: 'Communication Solves More Problems Than Technology Does.',
            text: "We've invested significantly in the right systems and tools. But the single biggest factor in client satisfaction is proactive communication—telling clients about an issue before they have to ask, explaining why something happened not just what. That doesn't require a platform. It requires discipline.",
            icon: 'fas fa-comments',
        },
        {
            num: '04',
            title: 'Growth Faster Than Quality Is Just a Slower Way to Fail.',
            text: "We have turned down clients when we didn't have the capacity to serve them properly. We have slowed hiring when training couldn't keep up. Turning down revenue is genuinely difficult. Rebuilding a reputation after growing too fast is harder.",
            icon: 'fas fa-balance-scale',
        },
    ]
    return (
        <section className="about-lessons td-section td-section--process rts-section-gap">
            <div className="container">
                <div className="td-section-head text-center mb-5">
                    <p className="td-section-label">Five Years In</p>
                    <h2 className="td-section-title">What Running Operations Actually Taught Us</h2>
                    <div className="td-title-rule td-title-rule--center mx-auto" aria-hidden="true" />
                </div>
                <div className="row g-4">
                    {lessons.map((lesson, i) => (
                        <div key={i} className="col-lg-6 col-md-12">
                            <div className="process-step-card h-100">
                                <div className="process-step-card__header">
                                    <div className="process-step-icon" aria-hidden="true">
                                        <i className={lesson.icon} />
                                    </div>
                                    <div className="process-step-card__head-text">
                                        <span className="step-num">{lesson.num}</span>
                                        <h3 className="step-title">{lesson.title}</h3>
                                    </div>
                                </div>
                                <p className="step-text">{lesson.text}</p>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    )
}

export default AboutLessonsLearned
